import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import Gt from "./trigger-condition.js";

var Kt = /*#__PURE__*/function () {
  function Kt(t, i) {
    _classCallCheck(this, Kt);

    this.fu = t, this.cu = i;
  }

  _createClass(Kt, [{
    key: "Ql",
    value: function Ql(t) {
      if (null == this.fu) return !1;
      var i = Gt.au(t[0], this.fu);
      if (!i) return !1;
      var r = null == this.cu || 0 === this.cu.length;
      if (null != this.cu) for (var _i = 0; _i < this.cu.length; _i++) {
        if (this.cu[_i] === t[1]) {
          r = !0;
          break;
        }
      }
      return i && r;
    }
  }, {
    key: "ss",
    value: function ss() {
      return this.fu;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new Kt(t ? t.id : null, t ? t.buttons : null);
    }
  }]);

  return Kt;
}();

export { Kt as default };